module.exports = __webpack_public_path__ + "static/media/monument.229d650d.svg";